import React from 'react';
import TextInput from '../../../common/TextInput';
import { useTranslation } from 'react-i18next';

type CreateProjectProps = {
  artistName?: string;
  projectName?: string;
  onArtistNameChange?: (value: string) => void;
  onProjectNameChange?: (value: string) => void;
};

export default function CreateProject(props: CreateProjectProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className="form-group">
        <TextInput
          labelClassName="modal-field-label"
          labelTitle={t('product.addToProjectModal.createProjectName')}
          handleInput={(e) => props.onProjectNameChange?.(e.target.value)}
          id="projectName"
          type="text"
          value={props.projectName ?? ''}
          inputClassname="form-control"
          className=""
        />
      </div>

      <div className="form-group">
        <TextInput
          labelClassName="modal-field-label"
          labelTitle={t('product.addToProjectModal.createProjectArtist')}
          handleInput={(e) => props.onArtistNameChange?.(e.target.value)}
          id="projectName"
          type="text"
          value={props.artistName ?? ''}
          inputClassname="form-control"
          className=""
        />
      </div>
    </>
  );
}
